import { useMutation } from '@tanstack/react-query';
import { useApiClientContext } from '../../surveys/context';
import { IBulkOperationResult, IFileAttachment } from '../../surveys/models/Api';
import { SurveyControllerType } from './types';

export const useClientUploadSurveyAttachmentByToken = ({
	onError,
	onSuccess,
}: {
	onError?: (error: IBulkOperationResult<IFileAttachment>) => void;
	onSuccess?: (data: IFileAttachment[]) => void;
}) => {
	const { apiClient } = useApiClientContext();

	return useMutation({
		mutationFn: ({
			file,
			accessToken,
			surveyType,
		}: {
			file: File;
			accessToken: string;
			surveyType: SurveyControllerType;
		}) => {
			const formData = new FormData();
			formData.append('files', file);

			return apiClient.postBulk<IFileAttachment>(
				`survey/${surveyType}/response/byToken/fileUpload?token=${accessToken}`,
				formData
			);
		},
		onError,
		onSuccess,
	});
};
